import GoogleMap from './map';
import Tabs from './tabs';

export default class ContactsMediator {
  constructor(mapWrap, mapID, marker, tabsWrap) {
    this.contactsPage = '.contacts-page';
    //this.$header      = $(this.contactsPage).find('.brand-header');

    // tabs
    this.instTabs 		= new Tabs(tabsWrap);
    this.$tabsWrap    = $(tabsWrap);
    this.tabs         = this.$tabsWrap.find('.tab-nav a');
    this.tabNav       = this.tabs.parent();
    this.firstTab     = this.tabs[0];

    // map
	  this.id 					= mapID;
	  this.mapWrap			= mapWrap;
    this.instMap  		= new GoogleMap(this.mapWrap, this.id);
    this.markers			=	this.$tabsWrap.find(marker);
    this.mapCenterLat = $(this.firstTab).parent().find('.map-marker .lat').html();
    this.mapCenterLng = $(this.firstTab).parent().find('.map-marker .lng').html();

    this.ACTIVE_CLASS = 'active';
    this.LOADED_CLASS = 'is-loaded';
  }
  // setContactsHeader = () => {
  //   const $cover  = this.$header.find('.brand-header__cover');
  //   const bg      = $cover.html();
  //
  //   this.$header.css('background-image', `url(${bg})`);
  //   this.$header.addClass(this.LOADED_CLASS);
  // };
  moveMapCenter = (cords) => {
    this.instMap.map.setCenter(cords.lat, cords.lng);
  };
  handleTabClick = (marker) => {
    this.moveMapCenter(this.instMap.getMarkerParams(marker, '.lat', '.lng'));
  };
  attachEventListeners = () => {
    [ ...this.tabs ].forEach(tab => {
      $(tab).on('click', () => {
        this.handleTabClick($(tab).next());
      });
    });
  };
  init = () => {
    //this.setContactsHeader();
    this.instTabs.init();
    this.instMap.createMapBlock(this.mapWrap);
    this.instMap.mapInit(this.id, this.mapCenterLat, this.mapCenterLng);
		[ ...this.markers ].forEach(marker => {
			this.instMap.setMarker(this.instMap.getMarkerParams(marker, '.lat', '.lng'));
		});
    this.attachEventListeners();
  }
}


// WEBPACK FOOTER //
// ./js/MediatorContacts.js